import React, { useState, useEffect } from 'react';
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from '../../utilities/BL/Zones';
import { GetPublicConfig } from '../../utilities/DL/MvpXolosZone';
import { MvpXolosZone as MvpXolosZoneOverlayView } from './Overlays/MvpXolosZone';

/**
 * COMPONENTE: MvpXolosZone OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * Este componente es el "Cerebro" del Overlay.
 * 1. Establece la conexión WebSocket / SignalR como "overlay:xolosmvpzone".
 * 2. Escucha los mensajes entrantes en tiempo real.
 * 3. Pasa la información al componente visual <MvpXolosZoneOverlayView />.
 * ------------------------------------------------------------------
 */
export function MvpXolosZone() {
    const [offsetY, setOffsetY] = useState(0);
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);
    const [bannerImageMdUrl, setBannerImageMdUrl] = useState('');
    const [bannerImageLgUrl, setBannerImageLgUrl] = useState('');
    const [connectionStatus, setConnectionStatus] = useState('idle');

    // Visibility flowState ('idle' | 'entering' | 'visible' | 'fadingOut')
    const [flowState, setFlowState] = useState('idle');

    // 1. Force Transparent Background for OBS Overlay
    useEffect(() => {
        const originalBodyBg = document.body.style.backgroundColor;
        const originalHtmlBg = document.documentElement.style.backgroundColor;
        const rootElement = document.getElementById('root');

        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        if (rootElement) {
            rootElement.style.backgroundColor = 'transparent';
        }

        return () => {
            document.body.style.backgroundColor = originalBodyBg;
            document.documentElement.style.backgroundColor = originalHtmlBg;
            if (rootElement) {
                rootElement.style.removeProperty('background-color');
            }
        };
    }, []);

    // 2. Control transitions (entering -> visible, fadingOut -> idle)
    useEffect(() => {
        let timeout;
        if (flowState === 'entering') {
            timeout = setTimeout(() => setFlowState('visible'), 500);
        } else if (flowState === 'fadingOut') {
            timeout = setTimeout(() => {
                setFlowState('idle');
            }, 500);
        }
        return () => clearTimeout(timeout);
    }, [flowState]);

    const handleOverlayVisibilityChange = (visible) => {
        if (visible) {
            setFlowState((prev) => {
                if (prev === 'idle' || prev === 'fadingOut') {
                    return 'entering';
                }
                return prev;
            });
        } else {
            setFlowState((prev) => {
                if (prev !== 'idle' && prev !== 'fadingOut') {
                    return 'fadingOut';
                }
                return prev;
            });
        }
    };

    // 3. Load Initial Settings and Connect WebSocket
    useEffect(() => {
        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            const type = message.type.toLowerCase();
            const data = message.data || message;

            if (type === 'config' || type === 'xolosmvpzone_config' || type === 'mvpxoloszone_config') {
                if (data.offsetY !== undefined) {
                    setOffsetY(data.offsetY);
                }
                if (data.bannerImageMdUrl !== undefined) {
                    setBannerImageMdUrl(data.bannerImageMdUrl);
                }
                if (data.bannerImageLgUrl !== undefined) {
                    setBannerImageLgUrl(data.bannerImageLgUrl);
                }
            } else if (type === 'state' || type === 'xolosmvpzone_state' || type === 'mvpxoloszone_state' || type === 'xolosmvpzone') {
                if (data.isOverlayVisible !== undefined) {
                    const isVisible = Boolean(data.isOverlayVisible);
                    setIsOverlayVisible(isVisible);
                    handleOverlayVisibilityChange(isVisible);
                }
                if (data.bannerImageMdUrl !== undefined) {
                    setBannerImageMdUrl(data.bannerImageMdUrl);
                }
                if (data.bannerImageLgUrl !== undefined) {
                    setBannerImageLgUrl(data.bannerImageLgUrl);
                }
                if (data.offsetY !== undefined) {
                    setOffsetY(data.offsetY);
                }
            }
        };

        const init = async () => {
            // Instalar manejador antes de conectar socket para atrapar snapshot inicial
            SetSocketMessageHandler(handleIncomingMessage);

            const res = await GetPublicConfig();
            if (res && res.success && res.data) {
                if (res.data.offsetY !== undefined) {
                    setOffsetY(res.data.offsetY);
                }
                if (res.data.bannerImageMdUrl) {
                    setBannerImageMdUrl(res.data.bannerImageMdUrl);
                }
                if (res.data.bannerImageLgUrl) {
                    setBannerImageLgUrl(res.data.bannerImageLgUrl);
                }
                const isVisible = Boolean(res.data.isOverlayVisible);
                setIsOverlayVisible(isVisible);
                setFlowState(isVisible ? 'visible' : 'idle');
            }

            await ConnectWebSocketForOverlay(
                'xolosmvpzone',
                (status) => setConnectionStatus(status),
                (msg) => console.log('[MvpXolosZone] WS Toast:', msg)
            );
        };

        init();

        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, []);

    return (
        <>
            <MvpXolosZoneOverlayView
                flowState={flowState}
                offsetY={offsetY}
                bannerImageMdUrl={bannerImageMdUrl}
                bannerImageLgUrl={bannerImageLgUrl}
            />

            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 5, right: 5, background: 'red', color: 'white', padding: '3px 8px', fontSize: '9px', borderRadius: '4px', opacity: 0.8, zIndex: 99999 }}>
                    D
                </div>
            )}
        </>
    );
}

export default MvpXolosZone;
